<template>
    <div class="slider-section">
        <p class="title">Nauči! Igraj! Osvoji!</p>

        <div class="img-wrap">
            <!-- <iframe src='https://player.vimeo.com/video/378984307' frameborder='0' webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe> -->
            <iframe class="holds-the-iframe" frameborder='0' webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>
        </div>

        <!-- <div class="img-wrap">
            <iframe src='https://player.vimeo.com/video/397194321' frameborder='0' webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>
        </div> -->

        <div class="partner-wrap" v-bind:class="{'full-width': !partnerLogoUrl}">
            <!-- TODO: not needed anymore as video has changed -->
            <!-- <p class="text">
                Odigraj probnu Ligu, pokaži svoje znanje i javi nam što misliš na <a href="mailto:info@tonimilun.hr">info@tonimilun.hr</a>
            </p> -->
            <span class="tag" v-if="partnerLogoUrl" :style="{'background-image': logoUrl}"></span>
        </div>

        <div class="button-wrap">
            <!-- TODO: Nagrade -->
            <a href="https://www.tonimilun.hr/store/" class="button-1 no-arrow blue" v-if="false"><span>Nagrade</span></a>

            <router-link v-on:click.native="sendGA('Probna liga')" to="/probno-pitanje/1" class="button-1 no-arrow red"><span>Probna liga</span></router-link>
            <router-link v-on:click.native="sendGA('Pravila')" to="/pravila" class="button-1 no-arrow red"><span>Pravila</span></router-link>
        </div>

        <ul class="socials" v-if="false">
            <li><a href="#" class="icon-face"></a></li>
            <li><a href="#" class="icon-viber"></a></li>
            <li><a href="#" class="icon-wapp"></a></li>
            <li><a href="#" class="icon-chain"></a></li>
        </ul>
    </div>
</template>

<script>

export default {
    name: 'slider-help',
    data: function () {
        return {
            globalDot: null,
            slickOptions: {
                arrows: false,
                speed: 300,
                slidesToShow: 1.2,
                slidesToScroll: 1,
                infinite: false
            },
            partnerLogoUrl: false
        }
    },
    computed: {
        logoUrl () {
            if (this.partnerLogoUrl) {
                return `url(${this.partnerLogoUrl})`
            }
            return false
        }
    },
    methods: {
        sendGA (button) {
            // eslint-disable-next-line no-undef
            gtag('event', 'click', {
                'event_category': 'Home',
                'event_label': `${button}`
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.slider-section {
    box-shadow: 0px 9px 16px 0px rgba(0,0,0,0.16);
    position: relative;
    display: block;
    background-color: #fff;
    border-radius: 5px;
    text-align: left;
    padding: 14px 12px;

    .title {
        font-family: "mPlus";
        font-size: 18px;
        letter-spacing: .2px;
        color: #000;
        margin-bottom: 10px;
    }
    .text {
        font-family: "axiforma";
        font-size: 12px;
        line-height: 18px;
        font-weight: 400;
        letter-spacing: .3px;
        color: #737a7f;
        margin: 0;

        a {
            color: #001840;
        }
    }
    .img-wrap {
        position: relative;
        padding-bottom: 55.667%;
        height: 0;
        overflow: hidden;
        max-width: 100%;
        height: auto;
        margin-bottom: 20px;

        iframe, object, embed {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            &.holds-the-iframe {
                background: url('~@/assets/img/1920x1080_otkazano.png');
                background-repeat: no-repeat;
                background-size: contain;
                background-position: center;
            }
        }
    }
    .partner-wrap {
        position: relative;
        padding-right: 134px;
        margin-bottom: 25px;
        &.full-width {
            padding-right: 0;
        }

        .tag {
            display: block;
            position: absolute;
            width: 111px;
            height: 42px;
            right: 0;
            top: calc(50% - 21.5px);
            background-position: 50%;
            background-size: contain;
            background-repeat: no-repeat;
        }
    }
    .button-wrap {
        display: flex;
        justify-content: space-between;
        text-align: center;
        margin-bottom: 25px;

        .button-1 {
            min-width: 135px;
        }
    }
}

.socials {
    display: flex;
    justify-content: space-between;
    a {
        display: block;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background-color: #a8a8a8;
        background-position: 50%;
        background-size: contain;
    }
    li:nth-child(1) a {
        background-color: #2f5f9e;
    }
    li:nth-child(2) a {
        background-color: #82469c;
    }
    li:nth-child(3) a {
        background-color: #00bf0b;
    }
}

</style>
